import { useState } from 'react'
import { useSelector } from 'react-redux'
import chinhSuaVanBangProcessor from '../../../processor/chinhSuaVanBangProcessor'
import { dateToDDMMYY } from '../../../utils/date'
import ListVanBangWithView from '../ListVanBangWithView'

const processor = chinhSuaVanBangProcessor

export default function DieuChinhDaDuyet() {
  const [reload, setReload] = useState(false)
  const toast = useSelector((store) => store.notify.toast)
  const additionColumn = [
    {
      value: 'chinhSuaVanBangs',
      name: 'Thông tin phản hồi',
      render: (data) => {
        return (
          <div>
            {data.chinhSuaVanBangs &&
              data.chinhSuaVanBangs
                .filter((item) => item.noiDung)
                .map((item) => (
                  <p>{`[${dateToDDMMYY(new Date(item.ngayTao))}] ${item.nguoiTao.fullname}: ${
                    item.noiDung
                  }`}</p>
                ))}
          </div>
        )
      },
    },
  ]
  const onSubmit = async (data) => {
    const rs = await processor.updateWithVanBang(data)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) setReload(true)
  }
  return (
    <>
      <ListVanBangWithView
        moduleTitle="Danh sách văn bằng chỉnh sửa đã duyệt"
        getMethod={processor.getVanBangChinhSuaDaDuyet}
        reload={reload}
        setReload={setReload}
        additionColumn={additionColumn}
        canEdit
        action={onSubmit}
      />
    </>
  )
}
